import React from 'react';
import {TextInput} from '@/components/atoms';
import styles from '../RewardSetup.module.scss';
import {preventInvalidNumericInput} from '../../../../utils/inputValidations';
import PropTypes from 'prop-types';

/**
 * PointsCondition component displays the points-based reward condition UI
 * Handles points input for POINTS and CASHBACK reward types
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing points value
 * @param {Function} props.handlePointsChange - Handler for points input changes
 * @param {string} props.pointsError - Error message for points validation
 * @param {string} props.type - Input type (default: "number")
 * @param {number} props.maxLength - Input type (default: null)
 * @returns {JSX.Element} The rendered PointsCondition component
 */
const PointsCondition = ({
  formData,
  handlePointsChange,
  pointsError,
  type = 'number',
  maxLength = null
}) => {
  return (
    <div className='flex flex-wrap gap-[13px]'>
      <span className='mt-2 whitespace-nowrap text-sm'>by redeeming</span>
      <div className={`w-32 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='text-sm placeholder:text-sm'
          value={formData?.redeemPoints || ''}
          onChange={handlePointsChange}
          label=''
          placeholderText='Points'
          error={pointsError}
          isDark={true}
          type={type}
          id='reward-points'
          handleKeyDown={preventInvalidNumericInput}
          maxLength={maxLength}
        />
      </div>
      <span className='mt-2 whitespace-nowrap text-sm'>points.</span>
    </div>
  );
};

PointsCondition.propTypes = {
  formData: PropTypes.object,
  handlePointsChange: PropTypes.func,
  pointsError: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number
};

export default PointsCondition;
